<template>
  <v-row>
    <v-col cols="12">
      <base-card v-if="searchResults && searchResults.length > 0">
        <v-card-text>
          <v-card-title>
            Listado de Eventos
            <v-spacer />
            <v-text-field
              v-model="localSearch"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="searchResults || []"
            :search="localSearch"
            class="elevation-1"
            @click:row="goToDetail"
            style="cursor: pointer"
          >
            <template v-slot:[`item.final_status`]="{ item }">
              <v-chip
                :color="getStatusColor(item.final_status)"
                dark
                small
                label
              >
                <v-icon left x-small>{{ getStatusIcon(item.final_status) }}</v-icon>
                {{ item.final_status }}
              </v-chip>
            </template>

            <template v-slot:[`item.has_errors`]="{ item }">
              <v-icon v-if="item.has_errors" color="red" small>mdi-alert-circle</v-icon>
              <v-icon v-else color="green" small>mdi-check-circle</v-icon>
            </template>

            <template v-slot:[`item.source_process`]="{ item }">
              {{ getProcessLabel(item.source_process) }}
            </template>

            <template v-slot:[`item.total_duration_ms`]="{ item }">
              {{ formatDuration(item.total_duration_ms) }}
            </template>

            <template v-slot:[`item.start_time`]="{ item }">
              {{ formatDate(item.start_time) }}
            </template>

            <template v-slot:[`item.consecutive`]="{ item }">
              {{ item.prefix }}-{{ item.consecutive }}
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import { getStatusColor, getStatusIcon, getProcessLabel, formatDuration } from '@/data/wideEventsStatuses'

  export default {
    name: 'ShowWideEvents',
    data () {
      return {
        localSearch: '',
        headers: [
          { text: 'Estado', value: 'final_status', align: 'center', width: '130px' },
          { text: 'Prefijo-Consecutivo', value: 'consecutive', align: 'center' },
          { text: 'Compañía', value: 'company_name', align: 'center' },
          { text: 'Proceso', value: 'source_process', align: 'center' },
          { text: 'Duración', value: 'total_duration_ms', align: 'center' },
          { text: 'Fecha', value: 'start_time', align: 'center' },
          { text: 'Errores', value: 'has_errors', align: 'center', width: '80px' },
        ],
      }
    },
    computed: {
      ...mapState('wideEvents', ['searchResults']),
    },
    methods: {
      getStatusColor,
      getStatusIcon,
      getProcessLabel,
      formatDuration,
      formatDate (dateStr) {
        if (!dateStr) return '-'
        const d = new Date(dateStr)
        return d.toLocaleString('es-EC', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      },
      goToDetail (item) {
        this.$router.push({
          name: 'wideEventDetail',
          params: { traceId: item.trace_id },
        })
      },
    },
  }
</script>

<style scoped>
</style>
